import { ChevronDown, ChevronRight } from 'react-feather';
import AdditionalOptions from '../orderSections/AdditionalOptions';

const OrderAdditionalOptionsSection = ({
	sections,
	toggleSection,
	handleFilterCategoryId,
	onDataChangeAdditionalOptions,
	sideWallSidingPanelsData,
	additionalbracing,
	AnchorsOptions,
	panelUpgradeOptions,
	leftLean,
	rightLean,
	frontLean,
	backLean,
	centerStorage,
	cSWidth,
	lLWidth,
	rLWidth,
	fLWidth,
	bLWidth,
	sideEndData,
}) => {
	return (
		<div className="tab-information">
			<div className="tab-information-block">
				<div
					className="title-block"
					onClick={(e) => toggleSection('aditionalsTab', e)}
				>
					<h2 className="title-h2">Additional options</h2>
					<button>
						{sections.aditionalsTab ? (
							<ChevronDown size={24} />
						) : (
							<ChevronRight size={24} />
						)}
					</button>
				</div>
				{sections.aditionalsTab && (
					<AdditionalOptions
						handleFilterCategoryId={handleFilterCategoryId}
						onDataChangeAdditionalOptions={onDataChangeAdditionalOptions}
						sideWallSidingPanelsData={sideWallSidingPanelsData}
						additionalbracing={additionalbracing}
						AnchorsOptions={AnchorsOptions}
						panelUpgradeOptions={panelUpgradeOptions}
						leftLean={leftLean}
						rightLean={rightLean}
						frontLean={frontLean}
						backLean={backLean}
						centerStorage={centerStorage}
						cSWidth={cSWidth}
						lLWidth={lLWidth}
						rLWidth={rLWidth}
						fLWidth={fLWidth}
						bLWidth={bLWidth}
						sideEndData={sideEndData}
					/>
				)}
			</div>
		</div>
	);
};

export default OrderAdditionalOptionsSection;
